import { checkAndUpdateToken } from "./auth";
import { SET_TESTING_CURRENT, SET_TESTING_LIST, SET_TESTING_LOADING, SET_TESTING_QUESTIONS, SET_TESTING_QUESTIONS_LIST, SET_TESTING_QUESTIONS_LOADING, SET_TESTING_STATISTIC, SET_TESTING_TOKEN, SET_TESTING_TRY, SET_QUESTIONS_FILES, SET_QUESTIONS_FILES_LOADING } from "./types";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";




export const getTestsList = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    dispatch({ type: SET_TESTING_LOADING, payload: true });

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/questionset`,
      {...buildDefaultHeaders(getState)}
    );

    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_TESTING_LIST, payload })
    }

    dispatch({ type: SET_TESTING_LOADING, payload: false });
  }
}

export const getCurrentTest = (testId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    dispatch({ type: SET_TESTING_LOADING, payload: true });

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/questionset/${testId}`,
      {...buildDefaultHeaders(getState)}
    );

    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_TESTING_CURRENT, payload })
      dispatch({ type: SET_TESTING_TRY, payload: !!payload?.availability_answers })
    }

    dispatch({ type: SET_TESTING_LOADING, payload: false });
  }
}

export const getTestTryInfo = (testId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/questionset/${testId}`,
      {...buildDefaultHeaders(getState)}
    );

    if (response.ok) {
      const respData = await response.json();
      const payload = !!respData?.availability_answers
      dispatch({ type: SET_TESTING_TRY, payload })
    }
  }
}

export const getTestQuestions = (id_set) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    dispatch({ type: SET_TESTING_LOADING, payload: true });

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/questionset/${id_set}/question/answers`,
      {...buildDefaultHeaders(getState)}
    );

    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_TESTING_QUESTIONS_LIST, payload })
    }

    dispatch({ type: SET_TESTING_LOADING, payload: false });
  }
}

export const addQuestionAnswer = (qsid, qid, data) => async (dispatch, getState) => {
  
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;
  let returnState = false
  try {
    dispatch({ type: SET_TESTING_QUESTIONS_LOADING, payload: true });
  
    const testToken = getState().testing.token
    const headers = buildDefaultHeaders(getState)
    headers.headers['X-Test-Session'] = testToken

    const response = await fetch(`${BACKEND_URL_PREFIX}/questionset/${qsid}/question/${qid}/answers`,
      {
        ...headers,
        method: "post",
        body: JSON.stringify(data)
      }
    );
  
    if (response.ok) {
      returnState = true
    }
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TESTING_QUESTIONS_LOADING, payload: false });
    return returnState
  }
};

export const getStatistic = (testId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/questionset/${testId}/user/statistic `,
      {...buildDefaultHeaders(getState)}
    );

    await dispatch(getTestTryInfo(testId))

    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_TESTING_STATISTIC, payload })
    }
  }
}

export const getQuestionsFile = (question_id) => async (dispatch, getState) => {
  dispatch({ type: SET_QUESTIONS_FILES_LOADING, payload: true})
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/questionset/${question_id}/file `,
      {...buildDefaultHeaders(getState)}
    );
    
    
    if (response.ok) {
      const { files } = await response.json();
      const payload = { [question_id]: files }
      dispatch({ type: SET_QUESTIONS_FILES, payload })
    }
  }
  dispatch({ type: SET_QUESTIONS_FILES_LOADING, payload: false})
}

export const startTest = (questionsetId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/questionset/${questionsetId}/start`,
      {
        ...buildDefaultHeaders(getState),
        method: 'POST',
      }
    );

    if (response.ok) {
      const {token} = await response.json();
      dispatch({ type: SET_TESTING_TOKEN, payload: token })
    }
  }
}

export const clearTestToken = () => (dispatch) => {
  dispatch({ type: SET_TESTING_TOKEN, payload: '' })
}

export const setGrade = (testId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    const testToken = getState().testing.token
    const headers = buildDefaultHeaders(getState)
    headers.headers['X-Test-Session'] = testToken

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/questionset/${testId}/user/grade`,

      {
        ...headers,
        method: 'POST',
      }
    );

    await dispatch(getTestTryInfo(testId))

    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_TESTING_STATISTIC, payload })
    }
  }
}